import React from 'react';
import { Accordion, Card, Icon } from '@weezevent/nacre';
import css from '../../styles.module.css';
import AttendeeForm from './AttendeeForm';
import SeatIcon from '../InventoriesStep/ManualModal/ModalSummary/SeatIcon';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../context/useAppContext';

export default function RateAttendees({
    form,
    selected_rate,
    attendees,
    categories,
    onChangeAttendee,
    onChangeFormAttendees,
    setFullScreenMode,
    setSelectedZone,
    setPreviousZone,
    setBackToSeats,
    onChangeSteps,
    bookingSelectionAuto
}) {
    const { t } = useTranslation();
    const [{ event }] = useAppContext();
    const attendeeCategory = React.useMemo(() => {
        if (form.use_inventories) {
            const category = categories.find(cat => cat.uuid === selected_rate.rate.resolved_category);
            return {
                name: category.name,
                id: category.uuid,
                color: category.color
            };
        }
    }, [attendees, categories]);

    if (!selected_rate.attendee_form || selected_rate.attendee_form.length < 1) {
        return (
            <Accordion
                disableToggle
                openByDefault
                title={
                    <div className={css['total-participants-container']}>
                        <span className={css['total-participants-category-title']}>{selected_rate.rate.name}</span>
                        <span className={css['total-participants']}>
                            <div>
                                <Icon name="user" />x{attendees.length}
                            </div>
                        </span>
                    </div>
                }
            >
                <Card.EmptyState
                    title={t('attendees.addAttendees.attendee-empty-title')}
                    subtitle={t('attendees.addAttendees.attendee-empty-subtitle')}
                    icon={<Icon name="list" />}
                />
            </Accordion>
        );
    }

    if (form.use_inventories) {
        return (
            <Accordion
                disableToggle
                openByDefault
                title={
                    <div className={css['total-participants-container']}>
                        <span className={css['total-participants-category-title']}>
                            {!event.isFakeSeating() && <SeatIcon color={attendeeCategory.color} id={attendeeCategory.id} />}
                            {event.isFakeSeating() ? selected_rate.rate.name : attendeeCategory.name}
                        </span>

                        <span className={css['total-participants']}>
                            <div>
                                <Icon name="user" />x{attendees.length}
                            </div>
                        </span>
                    </div>
                }
            >
                {attendees.map(attendee => {
                    return (
                        <AttendeeForm
                            key={attendee.id}
                            form={form}
                            attendee={attendee}
                            bookingSelectionAuto={bookingSelectionAuto}
                            fields={selected_rate.attendee_form || []}
                            onChangeFormAttendees={value => onChangeFormAttendees(attendee.id, value)}
                            onChangeAttendee={(key, value) => onChangeAttendee(attendee.id, key, value)}
                            setFullScreenMode={setFullScreenMode}
                            setSelectedZone={setSelectedZone}
                            setPreviousZone={setPreviousZone}
                            setBackToSeats={setBackToSeats}
                            onChangeSteps={onChangeSteps}
                        />
                    );
                })}
            </Accordion>
        );
    } else {
        return (
            <Accordion
                disableToggle
                openByDefault
                title={
                    <div className={css['total-participants-container']}>
                        <span className={css['total-participants-category-title']}>{selected_rate.rate.name}</span>
                        <span className={css['total-participants']}>
                            <div>
                                <Icon name="user" />x{attendees.length}
                            </div>
                        </span>
                    </div>
                }
            >
                {attendees.map((attendee, index) => {
                    return (
                        <AttendeeForm
                            key={attendee.id}
                            index={index}
                            form={form}
                            attendee={attendee}
                            fields={selected_rate.attendee_form || []}
                            onChangeFormAttendees={value => onChangeFormAttendees(attendee.id, value)}
                            onChangeAttendee={(key, value) => onChangeAttendee(attendee.id, key, value)}
                        />
                    );
                })}
            </Accordion>
        );
    }
}
